import { Controller } from '@hotwired/stimulus'

// 離れた場所にある<dialog>を開く汎用トリガー。Stimulusのaction探索はDOM祖先方向にしか
// 及ばないため、レイアウト側に1つだけ配置されたダイアログを複数箇所（カード・フッター等）
// から開きたい場合に使う。entryPointはdetailに載せて渡すだけで、使い道は呼び出し先に委ねる。
export default class extends Controller {
  static values = {
    dialogId: String,
    entryPoint: String
  }

  open() {
    const dialog = document.getElementById(this.dialogIdValue)
    if (!dialog) return

    dialog.showModal()
    this.dispatch('opened', { target: dialog, detail: { entryPoint: this.entryPointValue } })
  }
}
